import Swiper from 'swiper/bundle';
export function indexSlideFunc() {
  var topSwiper, topOptions;
  topSwiper = undefined;
  topOptions = {
    loop: true,
    autoplay: {
      delay: 3000
    },
    speed: 800,
    effect: 'slide',
    slidesPerView: 1.15,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1.75,
      }
    },
  };
  //スワイプ実行処理
  function initTopSwiper() {
    topSwiper = new Swiper('.swiper-container', topOptions);
  }
  initTopSwiper();
}
//トップページ　キービジュアルスライダー
export function idxTopixFunc() {
  $('.tab li').click(function () {
    var index = $('.tab li').index(this);
    $('.topicon > div').css('display', 'none');
    $('.topicon > div').eq(index).fadeIn("slow");
    $('.tab li').removeClass('select');
    $(this).addClass('select');
  });
}